var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBrandExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0704 11.4297L5.58203 9.71973V22.3549C5.58203 22.932 6.04007 23.3997 6.6051 23.3997H22.9776C23.5426 23.3997 24.0006 22.932 24.0006 22.3549V17.6997L15.0704 11.4297Z",
    fill: "#185C37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0704 0.599609H6.6051C6.04007 0.599609 5.58203 1.06738 5.58203 1.64442V6.29961L15.0704 11.9996L20.0937 13.7096L24.0006 11.9996V6.29961L15.0704 0.599609Z",
    fill: "#21A366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58203 6.2998H15.0704V11.9998H5.58203V6.2998Z",
    fill: "#107C41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M12.3729 5.16016H5.58203V19.4102H12.3729C12.9372 19.4083 13.3942 18.9416 13.396 18.3653V6.20496C13.3942 5.62871 12.9372 5.16203 12.3729 5.16016Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.8148 5.73047H5.58203V19.9805H11.8148C12.379 19.9786 12.836 19.5119 12.8378 18.9357V6.77528C12.836 6.19902 12.379 5.73234 11.8148 5.73047Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.8148 5.73047H5.58203V18.8405H11.8148C12.379 18.8386 12.836 18.3719 12.8378 17.7957V6.77528C12.836 6.19902 12.379 5.73234 11.8148 5.73047Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.2566 5.73047H5.58203V18.8405H11.2566C11.8209 18.8386 12.2779 18.3719 12.2797 17.7957V6.77528C12.2779 6.19902 11.8209 5.73234 11.2566 5.73047Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.02307 5.73047H11.256C11.821 5.73047 12.2791 6.19824 12.2791 6.77528V17.2256C12.2791 17.8027 11.821 18.2705 11.256 18.2705H1.02307C0.458041 18.2705 0 17.8027 0 17.2257V6.77528C0 6.19824 0.458041 5.73047 1.02307 5.73047Z",
    fill: "url(#paint0_linear_6643_23256)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16797 15.3962L5.32015 11.9905L3.34825 8.60352H4.93448L6.01057 10.7695C6.10993 10.9753 6.17801 11.128 6.21486 11.2289H6.22881C6.2995 11.0648 6.37392 10.9054 6.45206 10.7507L7.60238 8.60466H9.05857L7.03643 11.9717L9.10993 15.3962H7.56053L6.31755 13.0187C6.259 12.9176 6.20932 12.8113 6.16909 12.7013H6.15068C6.11426 12.8091 6.06596 12.9124 6.00667 13.0091L4.72686 15.3962H3.16797Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9775 0.599609H15.0703V6.29961H24.0005V1.64442C24.0005 1.06738 23.5425 0.599609 22.9775 0.599609Z",
    fill: "#33C481"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0703 12H24.0005V17.7H15.0703V12Z",
    fill: "#107C41"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6643_23256",
    x1: 2.13312,
    y1: 4.91408,
    x2: 10.4013,
    y2: 18.9363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBrandExcel);
export default __webpack_public_path__ + "static/media/logo-brand-excel.bfeaf4596011e91937e024cbaf1ee068.svg";
export { ForwardRef as ReactComponent };